export type TextToken = {
  type: 'TEXT'
  text: string
}
export type UserToken = {
  type: 'USER'
  userId: string
}

export type MessageToken = {
  type: 'MESSAGE'
  messageIid: number
}

export const getMessageToken = (messageIid: number): MessageToken | undefined =>
  messageIid
    ? {
        type: 'MESSAGE',
        messageIid,
      }
    : undefined
export const getTextToken = (text: string): TextToken | undefined =>
  text
    ? {
        type: 'TEXT',
        text,
      }
    : undefined

export const getUserToken = (userId: string): UserToken | undefined =>
  userId
    ? {
        type: 'USER',
        userId,
      }
    : undefined
